import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react'

interface SearchModalContextValue {
	isOpen: boolean
	open: () => void
	close: () => void
}

const SearchModalContext = createContext<SearchModalContextValue | undefined>(undefined)

export function SearchModalProvider({ children }: { children: ReactNode }) {
	const [isOpen, setIsOpen] = useState(false)

	const open = useCallback(() => {
		setIsOpen(true)
	}, [])

	const close = useCallback(() => {
		setIsOpen(false)
	}, [])

	const value = useMemo(
		() => ({
			isOpen,
			open,
			close,
		}),
		[isOpen, open, close],
	)

	return <SearchModalContext.Provider value={value}>{children}</SearchModalContext.Provider>
}

export function useSearchModal() {
	const context = useContext(SearchModalContext)
	if (!context) {
		throw new Error('useSearchModal must be used within a SearchModalProvider')
	}
	return context
}
